import { store, getContext, getElement } from '@wordpress/interactivity';
import blockDef from './block.json';
import { state as tabLayoutState } from '../TabLayout/front';

store(blockDef.amplify.viewNamespace, {
  state: {
    get isSelected() {
      const context = getContext();
      if (!Number.isInteger(context.index)) {
        return false;
      }

      return tabLayoutState.selectedIndex === context.index;
    },
  },

  actions: {},

  callbacks: {
    init: () => {
      const context = getContext();
      console.log(`[TabContentPane#init] context:`, context);
      const { ref } = getElement();
      console.log(`[TabContentPane#init] element content:`, ref.innerText);
      context.index = Array.from(ref?.parentElement?.children).indexOf(ref);
      console.log(`[TabContentPane#init] button index:`, context.index);
      console.log(
        `[TabContentPane#init] tabLayoutState.selectedIndex:`,
        tabLayoutState.selectedIndex
      );
    },
  },
});
